/*
 * Title: Successfull/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Successfully sign up popup.
 * Date: 12 Oct 2023
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, {
  Fragment,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import service from "@services/callback-service";
import { Dialog, Transition } from "@headlessui/react";
import { useSelector } from "react-redux";
import Etw from "./Etw";
import Loyalty from "./Loyalty";

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const Notification = forwardRef((props, ref) => {
  const config = useSelector((state: any) => state.creator?.program?.config);
  const notification = useSelector(
    (state: any) => state.user?.socketNotification
  );
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [tabActive, setTabActive] = useState(true);
  const [template, setTemplate] = useState(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setTabActive(document.visibilityState === "visible");
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    open(data) {
      if (document.visibilityState !== "visible") {
        setTabActive(false);
      } else {
        setTabActive(true);
      }
      setData(data);
    },
    close() {
      setVisible(false);
      setData([]);
    },
  }));

  useEffect(() => {
    if (tabActive && data.length > 0) {
      setVisible(true);
      const timer = setTimeout(() => {
        if (notification.length == 0) {
          setVisible(false);
          setData([]);
        }

        if (document.body.style.overflow === "hidden") {
          document.body.style.removeProperty("overflow");
        }
      
        const timer = setTimeout(() => {
          service.removeToNotificationQueue();
          setTimeout(() => {  
          if (document.documentElement.style.overflow === "hidden") {
              document.documentElement.style.removeProperty("overflow");
            }
          }, 500);
        }, 2000);
        return () => clearTimeout(timer);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [tabActive, notification.length, data.length]);

  if (data.length > 0 && visible) {
    return (
      <Transition.Root show={true} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => true}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#000]/80 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative w-screen h-full overflow-hidden pointer-events-auto">
                  {(config?.type == "etw" || config?.type == "ecommerce") ? (
                    <Etw data={data} />
                  ) : (
                    <Loyalty data={data} />
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }
  return null;
});
export default Notification;
